import { gql } from '@apollo/client';

export default gql`
  query profileLoyaltyPointsStatement($customerId: String!, $size: Int, $page: Int, $language: Language) {
    profileLoyaltyPointsStatement(customerId: $customerId, size: $size, page: $page, language: $language) {
      pagination {
        totalItems
        currentPage
        totalPages
      }
      items {
        actionBy
        bookingReference
        createdAt
        description
        rewardPoints
        statusPoints
        acceleratorPoints
        additionalNotes
        journalSubTypeName
        journalTypeName
        lastModifiedByName
        loyaltyProgramCurrency
        ticket
        currency
        transactionAmount
      }
    }
  }
`;
